"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var MerchandiseIds = _interopRequireWildcard(require("self-service-api/constants/MerchandiseIds"));

var _default = [[MerchandiseIds.PRODUCT_SALES_FREE, MerchandiseIds.PRODUCT_SALES_STARTER, MerchandiseIds.PRODUCT_SALES_PROFESSIONAL, MerchandiseIds.PRODUCT_SALES_ENTERPRISE], [MerchandiseIds.PRODUCT_MARKETING_FREE, MerchandiseIds.PRODUCT_MARKETING_STARTER, MerchandiseIds.PRODUCT_MARKETING_STARTER_EMAIL, MerchandiseIds.PRODUCT_MARKETING_BASIC, MerchandiseIds.PRODUCT_MARKETING_PROFESSIONAL, MerchandiseIds.PRODUCT_MARKETING_ENTERPRISE], [MerchandiseIds.ADDON_WEBSITE_STARTER, MerchandiseIds.ADDON_WEBSITE_UNLIMITED], [MerchandiseIds.PRODUCT_SERVICE_FREE, MerchandiseIds.PRODUCT_SERVICE_STARTER, MerchandiseIds.PRODUCT_SERVICE_PROFESSIONAL, MerchandiseIds.PRODUCT_SERVICE_ENTERPRISE]];
exports.default = _default;
module.exports = exports.default;